import { render, staticRenderFns } from "./waterPrice.vue?vue&type=template&id=e947d808&scoped=true"
import script from "./waterPrice.vue?vue&type=script&lang=js"
export * from "./waterPrice.vue?vue&type=script&lang=js"
import style0 from "./waterPrice.vue?vue&type=style&index=0&id=e947d808&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e947d808",
  null
  
)

export default component.exports